import { render, staticRenderFns } from "./StationHoverSummary.vue?vue&type=template&id=356c50f0&scoped=true"
import script from "./StationHoverSummary.vue?vue&type=script&lang=ts"
export * from "./StationHoverSummary.vue?vue&type=script&lang=ts"
import style0 from "./StationHoverSummary.vue?vue&type=style&index=0&id=356c50f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c50f0",
  null
  
)

export default component.exports